import React from 'react';
import { StarIcon } from 'lucide-react';
interface ReviewCardProps {
  name: string;
  location?: string;
  date: string;
  title?: string;
  content: string;
  rating?: number;
  avatar?: string;
  social?: boolean;
  socialInfo?: {
    likes?: number;
    replies?: number;
    timeAgo?: string;
  };
}
export function ReviewCard({
  name,
  location,
  date,
  title,
  content,
  rating = 5,
  // Default to 5 stars
  avatar,
  social = false,
  socialInfo
}: ReviewCardProps) {
  return <div className="bg-white rounded-lg p-5 mb-5 shadow-md border border-gray-200" data-id="element-503">
      <div className="flex items-center mb-2" data-id="element-504">
        {avatar ? <img src={avatar} alt={`${name}'s profile`} className="w-12 h-12 rounded-full mr-3 object-cover" data-id="element-505" /> : <div className="w-12 h-12 rounded-full bg-gray-200 mr-3 flex items-center justify-center text-lg font-bold" data-id="element-506">
            {name.charAt(0)}
          </div>}
        <div data-id="element-507">
          <h4 className="font-semibold" data-id="element-508">{name}</h4>
          <div className="flex items-center text-gray-500 text-sm" data-id="element-509">
            {location && <span data-id="element-510">{location}</span>}
            {location && <span className="mx-2" data-id="element-511">•</span>}
            <span data-id="element-512">{date}</span>
          </div>
        </div>
      </div>
      <div className="flex mb-2" data-id="element-513">
        {Array.from({
        length: 5
      }).map((_, i) => <div key={i} className="bg-green-500 p-1 mr-0.5 rounded-sm" data-id="element-514">
            <StarIcon className="w-4 h-4 text-white" data-id="element-515" />
          </div>)}
      </div>
      {title && <h3 className="font-bold text-lg mb-2" data-id="element-516">{title}</h3>}
      <div data-id="element-517">
        <p className="text-gray-700" data-id="element-518">{content}</p>
      </div>
      <div className="mt-3 flex items-center" data-id="element-519">
        <div className="flex items-center text-sm" data-id="element-520">
          <img src="https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-5.svg" alt="Trustpilot verified" className="h-5 mr-2" data-id="element-521" />
          <span className="text-gray-500" data-id="element-522">Verified review</span>
        </div>
      </div>
    </div>;
}